import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { TasksTab } from "./TasksTab";

interface JobTasksSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tasks: any[];
  onAddTask: () => void;
  onTaskUpdate?: () => void;
}

export const JobTasksSheet = ({
  open,
  onOpenChange,
  tasks,
  onAddTask,
  onTaskUpdate,
}: JobTasksSheetProps) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-4xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Tasks</SheetTitle>
        </SheetHeader>
        <div className="mt-6">
          <TasksTab
            tasks={tasks}
            onAddTask={onAddTask}
            onTaskUpdate={onTaskUpdate}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};
